// ClientLogicHandler.tsx
'use client';

import { cookieUtil } from '@/intl-jdi-common-ssr/utils/cookieUtils';
import { uaParse } from '@/intl-jdi-common-ssr/utils/uaParser';
import { useEffect } from 'react';
declare global {
  interface Window {
    actChannelId?: string;
  }
}
interface Props {
  crossDeviceId?: string;
  uuidv4: string;
  productPoolId: string;
}

export default function ClientLogicHandler({ crossDeviceId, uuidv4, productPoolId }: Props) {
  useEffect(() => {
    const { isInJoybuyApp } = uaParse();
    const cookieCrossDeviceId = cookieUtil.getCookie('crossDeviceId');
    // 只在客户端执行
    const handleClientLogic = async () => {
      // 检查window对象上是否已存在actChannelId，如果不存在则设置
      if (typeof window !== 'undefined' && !window.actChannelId) {
        window.actChannelId = productPoolId.toString();
      }
      if (!cookieCrossDeviceId || cookieCrossDeviceId.length === 0) {
        // 设置跨设备 ID
        cookieUtil.setCookie('crossDeviceId', uuidv4, 365);
      }
      if (isInJoybuyApp) {
        const params = {
          actChannelId: productPoolId.toString(),
          crossDeviceId:
            cookieCrossDeviceId && cookieCrossDeviceId.length > 0 ? cookieCrossDeviceId : uuidv4,
        };
        const bridgeModule = await import('@/utils/bridge');
        const JSBridge = bridgeModule.JSBridge;
        JSBridge.functionInApp({
          method: 'handleH5ReturnJson',
          payload: params,
        });
      }
    };

    handleClientLogic();
  }, [crossDeviceId, uuidv4]);

  return null; // 这个组件不渲染任何内容
}
